export default {
    NO_DATA_TEXT: "У вас нет ни одной папки",
    NOT_SELECTED_TEXT: "Для просмотра контента выберите папку на панели слева или создайте новую и добавьте в нее контент",
    ADD_FOLDER: "Создать папку"
};
